import { parse } from './html/utils';
import { clean as processGoogleDocs, matches as looksLikeGoogleDocs } from './html/cleaners/google-docs';
import { clean as processInterblocks, matches as looksLikeInterblocks } from './html/cleaners/interblocks';
import { clean as processSlate, matches as looksLikeSlate } from './html/cleaners/slate';
import { yankImagesUpToRoot, stripLoneBreaks, stripTopLevelBreaksBetweenImages, fixAnchorsAroundBlockElements, parseMarkdownImageSyntax } from './html/cleaners/general';
import { needsTableCleanup, stripTables } from './html/cleaners/tables';

//eslint-disable-line

export default function transformPastedHTML(html, config) {
  let provider = 'unknown';
  let root = parse(html);
  if (looksLikeGoogleDocs(html)) {
    root = processGoogleDocs(root);
    provider = 'Google Docs'; //eslint-disable-line
  } else if (looksLikeInterblocks(html)) {
    root = processInterblocks(root);
    provider = 'Interblocks'; //eslint-disable-line
  } else if (looksLikeSlate(html)) {
    root = processSlate(root);
    provider = 'Slate'; //eslint-disable-line
  }
  root = parseMarkdownImageSyntax(root);
  if (!looksLikeInterblocks(html)) {
    // We only need to pull images out for sources other than interblocks
    // Interblocks images are handled in the image#parseDOM function in node-specs
    // https://github.com/intercom/embercom-prosemirror-composer/blob/7d8dca4ff52b43164095259df77af3b35bfc1b20/addon/lib/config/specs/node-specs.ts#L299-L307
    root = yankImagesUpToRoot(root);
  }
  root = stripLoneBreaks(root);
  root = stripTopLevelBreaksBetweenImages(root);
  root = fixAnchorsAroundBlockElements(root);
  if (config.tables?.improvedPaste && needsTableCleanup(html)) {
    root = stripTables(root);
  }
  return {
    html: root.innerHTML,
    provider
  };
}